export enum enumIntegrate {
  NONE = "none",
  ALLOW_SUMMARY = "allowSummary",
  ACTIVE_GM_TOKEN = "activeGMToken",
  BOTH = "both",
}
